import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function GettingStartedIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3522">
      <div className="relative w-full h-full bg-gradient-to-br from-amber-100 to-orange-200 overflow-hidden" data-id="element-3523">
        {/* Background: Window and light */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3524">
          <rect x="140" y="20" width="40" height="60" rx="4" fill="#FDE68A" fillOpacity="0.5" data-id="element-3525" />
          <path d="M140 50 L180 50 M160 20 L160 80" stroke="#F59E0B" strokeWidth="2" strokeOpacity="0.3" data-id="element-3526" />
          <path d="M140 80 L60 200 L180 200 Z" fill="#FEF3C7" fillOpacity="0.4" data-id="element-3527" />
        </svg>

        {/* Background: Desk */}
        <svg className="absolute bottom-0 left-0 w-full h-1/3 z-0" viewBox="0 0 200 66" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3528">
          <path d="M0 40 L200 40 L200 66 L0 66 Z" fill="#B45309" data-id="element-3529" />
          <path d="M0 40 L200 40 L200 45 L0 45 Z" fill="#D97706" data-id="element-3530" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[15%]" data-id="element-3531">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3532">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} variant={variant} accessory="pencil" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3533" />
          </div>
        </div>

        {/* Foreground: Papers and desk items */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3534">
            {/* Stack of papers on desk */}
            <rect x="30" y="150" width="40" height="5" fill="#F8FAFC" transform="rotate(-5 30 150)" data-id="element-3535" />
            <rect x="32" y="145" width="40" height="5" fill="#F1F5F9" transform="rotate(-2 32 145)" data-id="element-3536" />
            <rect x="35" y="140" width="40" height="5" fill="#FFFFFF" data-id="element-3537" />

            {/* Floating papers */}
            <path d="M150 110 L170 105 L175 125 L155 130 Z" fill="white" transform="rotate(15 160 115)" data-id="element-3538" />
            <path d="M155 115 L165 112" stroke="#CBD5E1" strokeWidth="1.5" transform="rotate(15 160 115)" data-id="element-3539" />
            <path d="M153 120 L168 116" stroke="#CBD5E1" strokeWidth="1.5" transform="rotate(15 160 115)" data-id="element-3540" />

            <path d="M40 80 L60 70 L70 85 L50 95 Z" fill="white" transform="rotate(-20 55 80)" data-id="element-3541" />
            <path d="M45 82 L55 77" stroke="#CBD5E1" strokeWidth="1.5" transform="rotate(-20 55 80)" data-id="element-3542" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}